/* Perso Urban - vitrina de promociones (v2). No editar a mano: se regenera desde el sistema. */
(function () {
  if (window.__PersoPromo) return;
  window.__PersoPromo = { boot: boot };

  var FONTS = {
    system: 'inherit',
    condensed: "Impact,'Arial Narrow',sans-serif",
    mono: "ui-monospace,Menlo,Consolas,monospace",
    serif: "Georgia,'Times New Roman',serif"
  };

  var CSS = [
    '.pp-link{display:block;color:inherit;text-decoration:none}',
    '.pp-bar{display:flex;align-items:center;justify-content:center;gap:12px;flex-wrap:wrap;padding:8px 14px;min-height:40px;background:var(--pp-bg);color:var(--pp-fg);font-family:var(--pp-font);text-align:center;font-size:14px;line-height:1.2;box-sizing:border-box}',
    '.pp-text{font-weight:700;letter-spacing:.02em}',
    '.pp-pre{opacity:.85}',
    '.pp-count{display:inline-flex;align-items:center;gap:8px}',
    '.pp-unit{display:inline-flex;align-items:baseline;gap:2px}',
    '.pp-num{font-variant-numeric:tabular-nums;font-weight:800;font-size:1.2em}',
    '.pp-lbl{font-size:.7em;opacity:.8}',
    /* Neón */
    '.pp-t-neon{border-bottom:2px solid var(--pp-ac);box-shadow:0 0 14px var(--pp-ac)}',
    '.pp-t-neon .pp-num,.pp-t-neon .pp-text{color:var(--pp-ac);text-shadow:0 0 6px var(--pp-ac),0 0 14px var(--pp-ac)}',
    /* Flip */
    '.pp-t-flip .pp-unit{flex-direction:column;align-items:center;gap:3px}',
    '.pp-t-flip .pp-num{position:relative;background:rgba(0,0,0,.45);color:var(--pp-ac);border-radius:6px;padding:5px 8px;min-width:2ch;text-align:center;font-size:1.35em}',
    '.pp-t-flip .pp-num:after{content:"";position:absolute;left:0;right:0;top:50%;height:1px;background:rgba(255,255,255,.3)}',
    '.pp-t-flip .pp-lbl{text-transform:uppercase;letter-spacing:.08em;font-size:.6em}',
    /* Glitch */
    '.pp-t-glitch .pp-num,.pp-t-glitch .pp-text{text-shadow:2px 0 var(--pp-ac),-2px 0 #00e5ff;animation:pp-gl 2.4s infinite steps(1)}',
    '.pp-t-glitch .pp-unit{flex-direction:column;align-items:center}',
    '.pp-t-glitch .pp-lbl{text-transform:uppercase;font-size:.6em;letter-spacing:.1em}',
    '@keyframes pp-gl{0%,86%,100%{transform:none}88%{transform:translate(-2px,1px) skewX(-6deg)}92%{transform:translate(2px,-1px)}96%{transform:translate(-1px,0) skewX(5deg)}}',
    /* Gigante */
    '.pp-t-giant{padding:18px 14px;font-size:16px}',
    '.pp-t-giant .pp-unit{flex-direction:column;align-items:center;min-width:3.2em}',
    '.pp-t-giant .pp-num{font-size:2.8em;line-height:1}',
    '.pp-t-giant .pp-lbl{text-transform:uppercase;letter-spacing:.1em;font-size:.65em}',
    /* Animaciones */
    '.pp-a-pulse .pp-count{animation:pp-pulse 1.4s ease-in-out infinite}',
    '@keyframes pp-pulse{50%{transform:scale(1.06)}}',
    '.pp-a-glow .pp-num{animation:pp-glow 2s ease-in-out infinite}',
    '@keyframes pp-glow{50%{text-shadow:0 0 14px var(--pp-ac),0 0 28px var(--pp-ac)}}',
    '.pp-a-flicker .pp-num{animation:pp-fl 3s infinite steps(1)}',
    '@keyframes pp-fl{0%,90%,94%,100%{opacity:1}92%,96%{opacity:.35}}',
    '@media (prefers-reduced-motion:reduce){.pp-bar *{animation:none!important}}',
    /* Contador junto al precio (página de producto) */
    '.pp-inline{border-radius:10px;margin:12px 0;padding:10px 14px;justify-content:flex-start;text-align:left}',
    /* Etiquetas sobre tarjetas de producto */
    '.pp-etqs{position:absolute;top:8px;z-index:3;display:flex;flex-direction:column;gap:4px;pointer-events:none}',
    '.pp-etqs-l{left:8px;align-items:flex-start}',
    '.pp-etqs-r{right:8px;align-items:flex-end}',
    '.pp-etq{background:var(--pp-bg);color:var(--pp-fg);font:700 11px/1 system-ui,sans-serif;padding:5px 9px;letter-spacing:.04em;text-transform:uppercase;border-radius:999px;box-shadow:0 1px 4px rgba(0,0,0,.25)}',
    '.pp-etq-sq{border-radius:3px}'
  ].join('');

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function readData() {
    if (window.__PROMO_DATA__) return window.__PROMO_DATA__;
    var s = document.getElementById('promo-data');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function partes(ms, f) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    if (!f.d) { h += d * 24; d = 0; }
    if (!f.h) { m += h * 60; h = 0; }
    if (!f.m) { s += m * 60; m = 0; }
    var out = [];
    if (f.d && d > 0) out.push([d, 'd']);
    if (f.h) out.push([h, 'h']);
    if (f.m) out.push([m, 'm']);
    if (f.s) out.push([s, 's']);
    return out;
  }

  var LARGO = { d: 'días', h: 'hrs', m: 'min', s: 'seg' };

  function renderBar(host, bar) {
    var d = bar.design || {};
    var c = d.colors || {};
    var tx = d.texts || {};
    var f = d.format || { d: true, h: true, m: true, s: true };
    var plantilla = d.template || 'minimal';
    var largo = plantilla === 'flip' || plantilla === 'giant' || plantilla === 'glitch';

    var ahora = Date.now();
    if (bar.startsAt && new Date(bar.startsAt).getTime() > ahora) return;
    var fin = bar.endsAt ? new Date(bar.endsAt).getTime() : null;
    if (fin !== null && fin <= ahora) return;

    var wrap = el('div', 'pp-bar pp-t-' + plantilla + ' pp-a-' + (d.animation || 'none') + (bar.inline ? ' pp-inline' : ''));
    wrap.style.setProperty('--pp-bg', c.bg || '#111111');
    wrap.style.setProperty('--pp-fg', c.fg || '#ffffff');
    wrap.style.setProperty('--pp-ac', c.ac || '#ffffff');
    wrap.style.setProperty('--pp-font', FONTS[d.font] || FONTS.system);

    var raiz = wrap;
    if (bar.link) {
      raiz = el('a', 'pp-link');
      raiz.href = bar.link;
      raiz.appendChild(wrap);
    }

    function armar() {
      wrap.textContent = '';
      if (bar.text) wrap.appendChild(el('span', 'pp-text', bar.text));
      if (fin === null) return null;
      if (tx.prefix) wrap.appendChild(el('span', 'pp-pre', tx.prefix));
      var cuenta = el('span', 'pp-count');
      wrap.appendChild(cuenta);
      if (tx.suffix) wrap.appendChild(el('span', 'pp-pre', tx.suffix));
      return cuenta;
    }
    var cuenta = armar();
    host.appendChild(raiz);
    if (!cuenta) return;

    function pintar() {
      var falta = fin - Date.now();
      if (falta <= 0) {
        clearInterval(timer);
        if (tx.zero) { wrap.textContent = ''; wrap.appendChild(el('span', 'pp-text', tx.zero)); }
        else { raiz.parentNode && raiz.parentNode.removeChild(raiz); }
        return;
      }
      cuenta.textContent = '';
      var ps = partes(falta, f);
      for (var i = 0; i < ps.length; i++) {
        var u = el('span', 'pp-unit');
        u.appendChild(el('span', 'pp-num', pad(ps[i][0])));
        u.appendChild(el('span', 'pp-lbl', largo ? LARGO[ps[i][1]] : ps[i][1]));
        cuenta.appendChild(u);
      }
    }
    var timer = setInterval(pintar, 1000);
    pintar();
  }

  function handleDe(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  // Etiquetas sobre las tarjetas de producto (colecciones, inicio, buscador...)
  function pintarEtiquetas(data) {
    if (!data.labels || !data.labels.length) return;
    var tarjetas = document.querySelectorAll('.card-wrapper, .product-card, .product-item');
    for (var i = 0; i < tarjetas.length; i++) {
      var t = tarjetas[i];
      if (t.getAttribute('data-pp-etq')) continue;
      var a = t.querySelector('a[href*="/products/"]');
      if (!a) continue;
      var h = handleDe(a);
      if (!h) continue;
      t.setAttribute('data-pp-etq', '1');
      var host = t.querySelector('.card__inner, .card__media') || t;
      var cont = { l: null, r: null };
      for (var j = 0; j < data.labels.length; j++) {
        var lb = data.labels[j];
        if (lb.handles.indexOf(h) === -1) continue;
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
        var d = lb.design || {};
        var c = d.colors || {};
        var lado = d.position === 'top-right' ? 'r' : 'l';
        if (!cont[lado]) { cont[lado] = el('div', 'pp-etqs pp-etqs-' + lado); host.appendChild(cont[lado]); }
        var e = el('span', 'pp-etq' + (d.shape === 'square' ? ' pp-etq-sq' : ''), lb.text);
        e.style.setProperty('--pp-bg', c.bg || '#e11d48');
        e.style.setProperty('--pp-fg', c.fg || '#ffffff');
        cont[lado].appendChild(e);
      }
    }
  }

  // Contador junto al precio, en la página del producto
  function pintarContadorProducto(data) {
    if (!data.timers || !data.timers.length) return;
    var ruta = window.__PROMO_PATH__ || location.pathname;
    var m = ruta.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var h = decodeURIComponent(m[1]).toLowerCase();
    var lista = [];
    for (var i = 0; i < data.timers.length; i++) {
      if (data.timers[i].handles.indexOf(h) !== -1) lista.push(data.timers[i]);
    }
    if (!lista.length) return;
    var slot = document.querySelector('[data-promo-slot="product-timer"]');
    if (!slot) {
      var precio = document.querySelector('product-info .price, .product__info-container .price, .product .price');
      if (!precio || !precio.parentNode) return;
      slot = document.createElement('div');
      slot.setAttribute('data-promo-slot', 'product-timer');
      precio.parentNode.insertBefore(slot, precio.nextSibling);
    }
    slot.textContent = '';
    for (var j = 0; j < lista.length; j++) {
      renderBar(slot, { text: lista[j].text, endsAt: lista[j].endsAt, design: lista[j].design, inline: true });
    }
  }

  function boot() {
    var data = readData();
    if (!data) return;
    if (!document.getElementById('pp-css')) {
      var st = document.createElement('style');
      st.id = 'pp-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    var slots = document.querySelectorAll('[data-promo-slot="bar"]');
    for (var i = 0; i < slots.length; i++) {
      slots[i].textContent = '';
      for (var j = 0; j < (data.bars || []).length; j++) renderBar(slots[i], data.bars[j]);
    }
    pintarContadorProducto(data);
    pintarEtiquetas(data);
    if (window.MutationObserver && data.labels && data.labels.length && !window.__PersoPromoObs) {
      var pendiente = null;
      window.__PersoPromoObs = new MutationObserver(function () {
        clearTimeout(pendiente);
        pendiente = setTimeout(function () { pintarEtiquetas(data); }, 150);
      });
      window.__PersoPromoObs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
